module.exports = __webpack_public_path__ + "static/media/white-export-data-icon.88f55887.svg";